import { FC, HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";

export interface ILoginTitleProps extends HTMLAttributes<HTMLHeadingElement> {
    title: string;
}

const LoginTitle: FC<ILoginTitleProps> = ({ title, ...rest }) => {
    const {t} = useTranslation();
    return (
        <div className={`font-inter-bold color-primaryTextColor text-[20px] sm:text-3xl font-bold ${rest.className}`}>{t(title)}</div>
    )
}

export default LoginTitle